import { NgModule } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { CustomMycompanyComponent } from './custom-mycompany/custom-mycompany.component';
import { I18nModule, UrlModule } from '@spartacus/core';
import { IconModule } from '@spartacus/storefront';
import { RouterModule } from '@angular/router';
import { CustomGroupcompaniesComponent } from './custom-groupcompanies/custom-groupcompanies.component';
import { CustomContactsComponent } from './custom-contacts/custom-contacts.component';
import { CustomCompanyDetailsComponent } from './custom-company-details/custom-company-details.component';
import { CustomBhpteamComponent } from './custom-bhpteam/custom-bhpteam.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { CustomMyqoutesComponent } from './custom-myqoutes/custom-myqoutes.component';
import { MyContractsComponent } from './my-contracts/my-contracts.component';
import { FormModule } from '@spartacus/organization/administration/components';
import { CustomAddressbookComponent } from './custom-addressbook/custom-addressbook.component';
import {CustomProductsModule} from './custom-products/custom-products.module';

import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
// import { ClipboardModule } from 'ngx-clipboard';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import {AppPipesModule} from '../../shared/pipes/app-pipes';
import { CustomMyquotesDetailsComponent } from './custom-myquotes-details/custom-myquotes-details.component';
import { QuotesComponent } from './quotes/quotes-router.component';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { CustomAddcontactComponent } from './custom-addcontact/custom-addcontact.component';
import { CustomEditcontactComponent } from './custom-editcontact/custom-editcontact.component';

import { CustomInventoryManagementComponent } from './custom-inventory-management/custom-inventory-management.component';
import { InventoryUnpublishedBatchComponent } from './inventory-unpublished-batch/inventory-unpublished-batch.component';
import { CustomInventoryContentComponent } from './custom-inventory-content/custom-inventory-content.component';
import { CustomInventoryDetailsComponent } from './custom-inventory-details/custom-inventory-details.component';
import { CustomInventoryDetailsContentComponent } from './custom-inventory-details-content/custom-inventory-details-content.component';
import { CustomFAQComponent } from './custom-faq/custom-faq.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ShipmentComponent } from './shipment/shipment.component';
import { ShipmentFilterBarComponent } from './shipment/shipment-filter-bar/shipment-filter-bar.component';
import { ShipmentDetailsComponent } from './shipment-details/shipment-details.component';
import { TenderComponent } from './tender/tender.component';
import { ShipmentStatusDirective } from 'src/app/shared/components/shipment-status.directive';
import { RemoveLeadingZerosPipe,NoDecimalPipe } from 'src/app/shared/components/remove-leading-zeros.pipe';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { CustomHomeMenusComponent } from './custom-home-menus/custom-home-menus.component';
import { RecordPickupConfirmpopupComponent } from './shipment-vms/dvl-tracking/record-pickup-confirmpopup/record-pickup-confirmpopup.component';

@NgModule({
    imports: [
        CommonModule,
        UrlModule,
        IconModule,
        I18nModule,
        RouterModule,
        SharedModule,
        ReactiveFormsModule,
        FormModule,
        // ClipboardModule,
        CustomProductsModule,
        FormsModule,
        NgSelectModule,
        InfiniteScrollModule,
        AppPipesModule,
        NgbModule, NgMultiSelectDropDownModule.forRoot(),
        DecimalPipe,
        CustomMycompanyComponent,
        CustomGroupcompaniesComponent,
        CustomContactsComponent,
        CustomCompanyDetailsComponent,
        CustomBhpteamComponent,
        CustomMyqoutesComponent,
        MyContractsComponent,
        CustomAddressbookComponent,
        CustomMyquotesDetailsComponent,
        QuotesComponent,
        LandingPageComponent,
        CustomAddcontactComponent,
        CustomEditcontactComponent,
        CustomInventoryManagementComponent,
        InventoryUnpublishedBatchComponent,
        CustomInventoryContentComponent,
        CustomInventoryDetailsComponent,
        CustomInventoryDetailsContentComponent,
        CustomFAQComponent,
        ShipmentComponent,
        ShipmentFilterBarComponent,
        ShipmentDetailsComponent,
        TenderComponent,
        CustomHomeMenusComponent,
        RecordPickupConfirmpopupComponent
    ]
})
export class CustomLandingModule { }
